import { createContext, useState } from 'react'
import { ISidebarContext } from './@types'

export const SidebarContext = createContext<ISidebarContext>(
  {} as ISidebarContext,
)

export function SidebarContextProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const [open, setOpen] = useState<boolean>(false)
  const toggle = () => setOpen(!open)

  return (
    <SidebarContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </SidebarContext.Provider>
  )
}
